import { Checkbox, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';
import React from 'react';

// props : onChangeFunc : 체크박스 선택시 form을 이용하지 않고 값을 접근하고 싶을 때 사용.
const ControlledCheckBox = ({ name, options, style = {}, onChangeFunc = null }) => {
  const { control } = useFormContext();
  const {
    field: { ref, value, onChange, ...inputProps },
  } = useController({
    name,
    control,
    defaultValue: [],
  });

  const handleChange = (optionValue, option = null, event = null) => {
    const newArray = [...value];
    const index = newArray.indexOf(optionValue);
    if (index === -1) {
      newArray.push(optionValue);
    } else {
      newArray.splice(index, 1);
    }
    onChange(newArray);

    // onChangeFunc 존재 시 optionValue, option 전달.
    if (onChangeFunc) onChangeFunc(option, event);
  };

  // 기본 스타일
  const defaultStyle = {
    checkbox: {
      padding: 0.5,
      marginTop: '-1px',
      color: '#ddd',
      '&.Mui-checked': {
        color: '#0C8CE9',
      },
      ...style.checkbox,
    },
    label: {
      margin: 0,
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#767676',
      },
      ...style.label,
    },
  };

  return (
    <FormGroup>
      <Stack direction="row" spacing={1}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                sx={defaultStyle.checkbox}
                checked={value.includes(option.value)}
                {...inputProps}
                inputRef={ref}
                onChange={(event) => handleChange(option.value, option, event)}
              />
            }
            label={option.label}
            sx={defaultStyle.label}
          />
        ))}
      </Stack>
    </FormGroup>
  );
};

export default ControlledCheckBox;
